import { render, staticRenderFns } from "./SafetyProgramResolution.vue?vue&type=template&id=c4a4ce4e"
import script from "./SafetyProgramResolution.vue?vue&type=script&lang=js"
export * from "./SafetyProgramResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports